// components/info-cards/JobInfoCard.tsx
import { useEffect } from "react";

export function JobInfoCard({
  id,
  setHeader,
}: {
  id: string;
  setHeader?: (element: React.ReactNode) => void;
}) {
  // Set title
  useEffect(() => {
    if (setHeader) {
      const element = (
        <span className="font-semibold text-purple-600 flex items-center gap-2">
          <span>📋</span>
          <span>Задача {id}</span>
        </span>
      );
      setHeader(element);
    }
  }, [id, setHeader]);

  return (
    <div className="p-4 space-y-3">
      <h3 className="text-lg font-semibold">Задача {id}</h3>
      <div className="text-sm text-slate-600">Окно времени, точки, вес…</div>
    </div>
  );
}
